var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:[
    'inp_func',
    {
      none_text: !_vm.hasLabel,
    } ]},[_c('input',_vm._g(_vm._b({attrs:{"type":"radio"},domProps:{"checked":_vm._checked}},'input',_vm.attrs,false),_vm.listeners)),_c('span',{staticClass:"txt"},[_vm._t("default"),_vm._v(_vm._s(_vm.label))],2)])}
var staticRenderFns = []

export { render, staticRenderFns }